import { Link } from 'react-router-dom';
import { Icon } from '../../../components/ui';

/**
 * Botao "voltar" do HeroBanner das subtelas de disparo.
 *
 * E um Link (nao `history.back()`): quem chega direto pela URL, sem historico,
 * precisa conseguir subir para o hub. Preserva a busca da URL para o periodo
 * do cabecalho nao se perder na volta.
 */
export function VoltarPara({ to, label }: { readonly to: string; readonly label: string }): JSX.Element {
  return (
    <Link
      to={{ pathname: to, search: window.location.search }}
      aria-label={`Voltar para ${label}`}
      title={`Voltar para ${label}`}
      className="grid h-9 w-9 shrink-0 place-items-center rounded-lg border border-line bg-surface text-ink-muted shadow-soft transition-colors hover:border-brand/60 hover:text-brand"
    >
      <Icon name="seta-esq" size="sm" />
    </Link>
  );
}
